import React from "react";
import Routes from "./Roues";
import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <CartProvider>
      <Routes />
    </CartProvider>
  );
}

export default App;
